import React from 'react';
import { DealProps } from '../../types/deal';
import CompactDealCard from './CompactDealCard';
import AnalyticsService from '../../services/analyticsService';
import CardWidget from '../common/CardWidget';
import { WIDGET_LOADING_STATES, WIDGET_EMPTY_STATES } from '../../types/CardWidget';
import './TrendingDeals.css';

interface TrendingDealsProps {
  deals?: DealProps[];
  loading?: boolean;
  error?: string | null;
}

const TrendingDeals: React.FC<TrendingDealsProps> = ({
  deals = [],
  loading = false,
  error = null,
}) => {
  // Take first 4 deals as "trending" (could be enhanced with actual trending logic)
  const trendingDeals = deals.slice(0, 4);

  const handleViewAll = async (e: React.MouseEvent) => {
    try {
      await AnalyticsService.trackEvent({
        eventType: 'page_view',
        metadata: {
          action: 'trending_deals_view_all',
          source: 'home_sidebar',
        },
      });
    } catch (error) {
      console.error('Error tracking view all interaction:', error);
    }
  };

  return (
    <CardWidget
      title="Trending Deals"
      icon="🔥"
      className="trending-deals-container"
      actionLink={{
        text: 'View All',
        href: '/trending',
        onClick: handleViewAll,
      }}
      loading={loading ? WIDGET_LOADING_STATES.TRENDING : undefined}
      error={error ? { message: error } : undefined}
      empty={
        trendingDeals.length === 0 && !loading && !error ? WIDGET_EMPTY_STATES.TRENDING : undefined
      }
      testId="trending-deals-widget"
      ariaLabel="Trending deals widget"
    >
      {trendingDeals.length > 0 && (
        <div className="trending-deals-list">
          {trendingDeals.map((deal) => (
            <CompactDealCard key={deal._id} deal={deal} />
          ))}
        </div>
      )}
    </CardWidget>
  );
};

export default TrendingDeals;
